// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'

import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/common.scss'
import '@/css/iconfont.css'
import '@/assets/scss/global.scss'
import httpRequest from '@/utils/httpRequest'
import { getSelectDesc } from '@/utils'

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.getSelectDesc = getSelectDesc // 获取枚举描述
Vue.prototype.$bus = new Vue() // 全局事件总线（登录弹窗等）

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js